module.exports = __webpack_public_path__ + "static/media/Simpsons logo white grey.3812fa45.avif";